import { memo, useEffect, useState } from "react";
import { useBacklistData } from "hooks/search/useBacklistData";
import { useSession } from "contexts/AuthContext";
import { SearchType } from "hooks/search/types";
import { CatalogAnalyticsProvider, useCatalogAnalytics } from "./analytics";
import { HybridBooksTable } from "./table/HybridBooksTable";
import { RegularBooksTable } from "./table/RegularBooksTable";

const BooksPageContent = memo(() => {
  const { organisation } = useSession();
  const { clearPendingIntent } = useCatalogAnalytics();

  const {
    data: { products, count, total },
    isLoading,
    searchQuery,
    setSearchQuery,
    error,
    fetchAllResults,
    ageRangeAvailableBounds,
  } = useBacklistData();

  const isHybrid = searchQuery.type === SearchType.HYBRID;

  const [rowSelection, setRowSelection] = useState({});

  useEffect(() => {
    setRowSelection({});
    clearPendingIntent();
  }, [setRowSelection, clearPendingIntent, organisation.id]);

  return (
    <div className="space-y-8">
      {isHybrid ? (
        <HybridBooksTable
          isLoading={isLoading}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          error={error}
          products={products}
          count={count}
          total={total}
          fetchAllResults={fetchAllResults}
          setRowSelection={setRowSelection}
          rowSelection={rowSelection}
          ageRangeAvailableBounds={ageRangeAvailableBounds}
        />
      ) : (
        <RegularBooksTable
          isLoading={isLoading}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          error={error}
          products={products}
          count={count}
          total={total}
          fetchAllResults={fetchAllResults}
          setRowSelection={setRowSelection}
          rowSelection={rowSelection}
          ageRangeAvailableBounds={ageRangeAvailableBounds}
        />
      )}
    </div>
  );
});

BooksPageContent.displayName = "BooksPageContent";

export const BooksPage = memo(() => (
  <CatalogAnalyticsProvider>
    <BooksPageContent />
  </CatalogAnalyticsProvider>
));

BooksPage.displayName = "BooksPage";
